import { apiClient } from "./client";
import type { ChatApiResponse, CheckpointResponse } from "../schemas";

export const studentService = {
  /**
   * Send a chat message to the AI
   */
  sendMessage: (message: string, conversationId: string | null) =>
    apiClient.post<ChatApiResponse>("/api/chat", {
      message,
      conversationId,
    }),

  /**
   * Submit a checkpoint response
   */
  submitCheckpoint: (conversationId: string, response: CheckpointResponse) =>
    apiClient.post<{ success: boolean }>("/api/checkpoint", {
      conversationId,
      response,
    }),
};
